import React from "react";
import { ReactComponent as EditIcon } from "../../img/PencilFill.svg";
import { ReactComponent as DeleteIcon } from "../../img/TrashFill.svg";
import { ContactData } from ".";

interface ContactCardProps {
  contact: ContactData;
  onEdit: (id: number) => void;
  onDelete: (id: number) => void;
}

const ContactCard: React.FC<ContactCardProps> = ({
  contact,
  onEdit,
  onDelete,
}) => (
  <div className="contactCard">
    <div className="contactInfo">
      <div className="contactName">{contact.col1_1}</div>
      <div>{contact.col1_2}</div>
    </div>
    <div className="contactDetails">
      <div className="infoCard-personal">{contact.col2_1}</div>
      <div className="infoCard-official">{contact.col2_2}</div>
    </div>
    <div className="actions">
      <button
        className="btn btn-default btn-sm"
        onClick={() => onEdit(contact.col2_3)}
      >
        <EditIcon />
      </button>
      <button
        className="btn btn-default btn-sm"
        onClick={() => onDelete(contact.col2_3)}
      >
        <DeleteIcon />
      </button>
    </div>
  </div>
);

export default ContactCard;
